import React, {useState, useEffect, useCallback} from "react";
import ErrorModal from "./ErrorModal";
import SubmissionListContent, {ItemPricing} from "./SubmissionListContent";
import AddressFormContainerModal from "./AddressFormContainerModal";
import I18n from 'i18n.js.erb'
import {
  isValidUserAddress,
  parseSubmissionListState,
  CURRENCY_EURO,
  parseAmount,
  submissionListColorState,
  isDefined,
  titleize,
  isPresent,
  parseFeedbackName,
  SUBMISSION_LISTS_EVALUATIONS,
  hasVoucher,
  VERY_HIGH_DEBOUNCE_TIME,
  getEvaluationByFeedback,
  insuranceRequested,
  insuranceServiceEnabled,
  homePickUpServiceEnabled,
  returnShipmentServiceEnabled,
  renderHomePickuServiceDetails,
  renderReturnShipmentServiceDetails,
  SUBMISSION_LIST_POSTERIOR_UPON_RECEIPT_STATES,
  isInAClosingState,
  hasValidVoucher,
  HIGH_DEBOUNCE_TIME
} from "../../utils/utils";
import ShowLargeImageModal from "./ShowLargeImageModal";
import PDFGenerator from "./PDFGenerator";
import SuccessFlashMessage from "./SuccessFlashMessage";
import Address from "./Address";
import {debounce} from "lodash";


const SubmissionListSingleDetailSummary = ({
  iconPath,
  label,
  content,
  iconCssAdditionalClass,
  customHtml,
  labelCssClass,
  textTruncate
}) => {

  return <React.Fragment>
    <div>
      <img src={window.location.origin + iconPath} alt="" className={iconCssAdditionalClass ? iconCssAdditionalClass : ''} />
    </div>
    <div className={`d-block pl-2 ${textTruncate ? 'text-truncate' : 'text-on-new-line'}`}>
      <p className={`${textTruncate ? 'text-truncate' : ''} mt-1`}>
        <span className={`${labelCssClass ? labelCssClass : 'default_small_label'} mr-2`}>
          {label}
        </span>
      </p>
      {
        customHtml ?
          <div dangerouslySetInnerHTML={{ __html: customHtml }}></div>
        :
          <p className={`${textTruncate ? 'text-truncate' : 'text-on-new-line'}`}>
            { content }
          </p>
      }
    </div>
  </React.Fragment>
}


export const UserGeneralitiesSummary = ({
  submissionList,
  isMiddleman,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/user.svg"}
    label={isMiddleman || !submissionList.middleman ? I18n.t('js.indexSubmissionListsPage.tableHeaderUserOwnerGenerality').toUpperCase() : submissionList.company_point.toUpperCase()}
    content={isMiddleman || !submissionList.middleman ? submissionList.user_owner : submissionList.middleman.business_name}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const UserEmailSummary = ({
  submissionList,
  isMiddleman,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/email.svg"}
    label={(isMiddleman || !submissionList.middleman ? I18n.t('js.indexSubmissionListsPage.tableHeaderUserOwnerEmail') : submissionList.company_point + ' ' + I18n.t('js.indexSubmissionListsPage.tableHeaderUserEmail')).toUpperCase()}
    content={isMiddleman || !submissionList.middleman ? submissionList.owner_email : submissionList.middleman?.email}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const ConfirmationDateSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/calendar.svg"}
    label={I18n.t("js.indexSubmissionListsPage.tableHeaderConfirmedAt").toUpperCase()}
    content={submissionList.confirmed_at}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const ItemsCountSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/balls.svg"}
    label={I18n.t("js.indexSubmissionListsPage.tableHeaderItemsCount").toUpperCase()}
    content={submissionList.items_count}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const DiscountSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/discount.svg"}
    label={I18n.t("js.PDFGenerator.submissionLists.discount_code").toUpperCase()}
    content={hasVoucher(submissionList) && isDefined(submissionList.voucher?.code) ? submissionList.voucher.code : I18n.t("js.common.none")}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const InsuranceServiceSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/shield.svg"}
    label={I18n.t("js.indexSubmissionListsPage.insurance").toUpperCase()}
    content={ I18n.t(`js.common.choice_${insuranceRequested(submissionList) ? 'yes' : 'no'}`) + (insuranceRequested(submissionList) && submissionList.insured_value ? ' - ' + I18n.t("js.indexSubmissionListsPage.insuranceUpperLimit") + ' ' + parseAmount(submissionList.insured_value, 2) + CURRENCY_EURO : '')}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const HomePickUpServiceSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/home_pick_up.svg"}
    label={I18n.t("js.PDFGenerator.submissionLists.home_pick_up").toUpperCase()}
    content={I18n.t(`js.common.choice_${submissionList.home_pick_up_requested ? 'yes' : 'no'}`)}
    iconCssAdditionalClass={'mt-1'}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const ReturnShipmentServiceSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/return_shipment.svg"}
    label={I18n.t("js.editSubmissionListPage.webComponent.draft.payment.shipping_cost").toUpperCase()}
    content={I18n.t(`js.common.choice_${submissionList.return_delivery_requested ? 'yes' : 'no'}`)}
    iconCssAdditionalClass={'mt-1'}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}




const ShowPageSubmissionList = ({
    originalSubmissionList,
    countries,
    canEditSubmissionList
  }) => {

  const original_submission_list = JSON.parse(originalSubmissionList);
  const isMiddleman = original_submission_list?.is_middleman;
  const [ initCompleted, setInitCompleted ] = useState(false);
  const [ evaluations, setEvaluations ] = useState(original_submission_list.evaluations);
  const [ feedbacks, setFeedbacks ] = useState(original_submission_list.grader_company?.feedbacks);
  const [ review, setReview ] = useState(original_submission_list.review);
  const [ showSuccessFlashMessage, setShowSuccessFlashMessage ] = useState(false);
  const [ showErrorModal, setShowErrorModal ] = useState(false);
  const [ showModal, setShowModal ] = React.useState(false);
  const [ shipmentAddress, setShipmentAddress ] = useState(original_submission_list.shipment_address ? { ...original_submission_list.shipment_address } : null);
  const [ showZoomImg, setShowZoomImg ] = useState(false);
  const [ blueprintImage2ShowLargeImage, setBlueprintImage2ShowLargeImage ] = useState(null);
  const [ middlemanNote, setMiddlemanNote ] = useState(original_submission_list.middleman_note);
  const [ editMiddlemanNote, setEditMiddlemanNote ] = useState(false);

  // console.log('original_submission_list: ', original_submission_list);

  useEffect(() => {
    if (!initCompleted)
      setInitCompleted(true);
  }, []);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateReview();
      return debouncedUpdateReview.cancel;
    }
  }, [review, debouncedUpdateReview]);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateMiddlemanNote();
      return debouncedUpdateMiddlemanNote.cancel;
    }
  }, [middlemanNote, debouncedUpdateMiddlemanNote]);


  // Funzione che esegue l'update debouncato della recensione data dall'utente alla submission list
  const debouncedUpdateReview = useCallback(
    debounce(() => {
      if (isPresent(review)) {
        updateReview()
      }
    }, VERY_HIGH_DEBOUNCE_TIME),
    [review]
  );


  // Funzione che esegue l'update debouncato delle note immesse dall'aggregatore per la submission list
  const debouncedUpdateMiddlemanNote = useCallback(
    debounce(() => {
      if (isPresent(middlemanNote)) {
        updateMiddlemanNote()
      }
    }, HIGH_DEBOUNCE_TIME),
    [middlemanNote]
  );


  // Funzione che permette di aggiornare i vari campi che compongono l'indirizzo di spedizione
  // con i dati immessi dall'utente sull'interfaccia grafica
  const updateShipmentAddressParams = (keys, values) => {
    const newShipmentAddress = {...shipmentAddress}
    for (let i = 0; i < keys.length; i++)
      newShipmentAddress[keys[i]] = values[i]
    setShipmentAddress(newShipmentAddress)
  }


  //Funzione che aggiorna l'indirizzo di spedizione scelto dall'utente
  function updateShipmentAddress() {
    if (shipmentAddress.can_be_updated && canEditSubmissionList) {
      if (isValidUserAddress(shipmentAddress)) {
        let url = `/submission_lists/update_shipment_address/${original_submission_list.id}.json${isMiddleman ? '?user_id=' + original_submission_list.user_id : ''}`;

        fetch(url, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(shipmentAddress),
        })
          .then((res) => {
            if (!res.ok)
              throw Error("An error occour during saving data on the database");
            else
              return res.json()
          })
          .then((data) => {
            setShipmentAddress({...shipmentAddress})
            setShowModal(false)
            setShowSuccessFlashMessage(true)
          })
          .catch((error) => {
            console.error("ERROR:", error);
            setShowErrorModal(true);
          });

      }
    }
  }


  // Funzione che permette di mostrare in full-screen l'immagine ingrandita di una carta
  const handleShowLargeImage = (e, blueprintImage) => {
    e.stopPropagation();
    if (blueprintImage && blueprintImage.xx_large_image_url) {
      setBlueprintImage2ShowLargeImage(blueprintImage)
      setShowZoomImg(true)
    }
  }


  // Funzione che verifica se la submission list corrente possa essere valutata e recensita dall'utente
  // sull'interfaccia grafica
  const cabBeEvaluated = () => {
    return original_submission_list.can_be_evaluated_by_current_user && !original_submission_list.evaluation_time_limit_expired
  }


  // Funzione che aggiorna la valutazione dell'utente in corrispondenza di un determinato feedback della submission list
  const updateEvaluation = (feedbackId, value) => {
    if (cabBeEvaluated()) {
      let url = `/submission_lists/${original_submission_list.id}`;

      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({evaluation: { feedback_id: feedbackId, value: value }}),
      })
        .then((res) => {
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json()
        })
        .then((data) => {
          const newEvaluations = (isDefined(evaluations) ? {...evaluations} : {})
          newEvaluations[feedbackId] = value;
          setEvaluations(newEvaluations);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che aggiorna la recensione data dall'utente alla submission list
  const updateReview = () => {
    if (cabBeEvaluated()) {
      let url = `/submission_lists/${original_submission_list.id}`;

      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({review: review}),
      })
        .then((res) => {
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json()
        })
        .then((data) => { })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che aggiorna le note immesse dall'aggregatore per la submission list
  const updateMiddlemanNote = () => {
    let url = `/submission_lists/${original_submission_list.id}`;

    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({middleman_note: middlemanNote}),
    })
      .then((res) => {
        if (!res.ok)
          throw Error("An error occour during saving data on the database");
        else
          return res.json()
      })
      .then((data) => { })
      .catch((error) => {
        console.error("ERROR:", error);
        setShowErrorModal(true);
      });
  }



  return (
    <React.Fragment>
      {
        initCompleted &&
          <React.Fragment>
            {/*  HEADER DELLA PAGINA */}
            <div className="row d-block justify-content-center text-center bg-aig-gradient w-100 m-0 color-white py-4 border-bottom-radius-20px px-3">
              <div>
                <h2><b>{I18n.t('js.filters.order')} {original_submission_list.number}</b></h2>
              </div>
              {
                original_submission_list.title &&
                  <div>
                    <h3><b>{original_submission_list.title}</b></h3>
                  </div>
              }
            </div>




            {/*  SEZIONE DATI DI RIEPILOGO DELLA SUBMISSION LIST */}
            <div id="submission_list_summary_details" className="pb-3">
              <div className="row shadow border-bottom-radius-8px border-aiG-gray-imp border-top-none-imp">
                {
                  (isMiddleman || original_submission_list.middleman) &&
                    <React.Fragment>
                      <div className="col-6 py-1 px-2 d-flex justify-content-start border-right-solid border-bottom-solid">
                        <UserGeneralitiesSummary
                          submissionList={original_submission_list}
                          isMiddleman={isMiddleman}
                        />
                      </div>

                      <div className="col-6 py-1 px-2 d-flex justify-content-start border-bottom-solid">
                        <UserEmailSummary
                          submissionList={original_submission_list}
                          isMiddleman={isMiddleman}
                        />
                      </div>
                    </React.Fragment>
                }

                <div className="col-6 col-lg-3 py-1 px-2 d-flex justify-content-start border-right-solid border-bottom-solid">
                  <ConfirmationDateSummary
                    submissionList={original_submission_list}
                  />
                </div>

                <div className="col-6 col-lg-3 py-1 px-2 d-flex justify-content-start border-right-lg-solid border-bottom-solid">
                  <ItemsCountSummary
                    submissionList={original_submission_list}
                  />
                </div>


                <div className="col-6 col-lg-3 py-1 px-2 d-flex justify-content-start border-right-solid border-bottom-solid">
                  <div>
                    <img src={window.location.origin + `/images/icons/gray/money.svg`} alt="amount" />
                  </div>
                  <div className="d-block pl-2">
                    <p className="mt-1">
                      <small className="default_small_label mr-2">
                        {I18n.t("js.editSubmissionListPage.amount").toUpperCase()}
                      </small>
                    </p>
                    <div className="d-flex align-items-center">
                      <ItemPricing
                        item={original_submission_list}
                        amountToRender={isMiddleman ? 'amount' : 'customer_amount'}
                      />
                      <div className="my-0 pb-1">
                        <img src={window.location.origin + `/images/icons/circle-arrow-down.svg`}
                             className="ml-2 cursor-pointer" width="16" height="16" alt="pricing_summary_link"
                             onClick={() => document.querySelector('#pricing_summary_section').scrollIntoView(false)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-6 col-lg-3 py-1 px-2 d-flex justify-content-start border-bottom-solid">
                  <div>
                    <img src={window.location.origin + `/images/icons/gray/state.svg`} alt="state"/>
                  </div>
                  <div className="d-block pl-2">
                    <p className="mt-1">
                      <small className="default_small_label mr-2">
                        {I18n.t("js.filters.sort.state").toUpperCase()}
                      </small>
                    </p>
                    <p>
                      <b style={{ color: submissionListColorState(original_submission_list.front_office_state) }}>
                        { titleize(parseSubmissionListState(original_submission_list.front_office_state)) }
                      </b>
                      {
                        original_submission_list.state === 'closed' ?
                          ` ${I18n.t("js.common.onDate")} ${original_submission_list.closed_at}`
                        :
                          original_submission_list.state === 'received' &&
                            ` ${I18n.t("js.common.onDate")} ${original_submission_list.received_at}`
                      }
                    </p>
                  </div>
                </div>

                <div className="col-6 col-lg-3 py-1 px-2 d-flex justify-content-start border-right-solid border-bottom-solid border-bottom-lg-none">
                  <DiscountSummary
                    submissionList={original_submission_list}
                  />
                </div>

                <div className="col-6 col-lg-3 py-1 px-2 d-flex justify-content-start border-right-lg-solid border-bottom-solid border-bottom-lg-none minH-79px">
                  {
                    insuranceServiceEnabled(original_submission_list) ?
                      <InsuranceServiceSummary
                        submissionList={original_submission_list}
                      />
                    :
                      renderHomePickuServiceDetails(original_submission_list) ?
                        <HomePickUpServiceSummary
                          submissionList={original_submission_list}
                        />
                      :
                        renderReturnShipmentServiceDetails(original_submission_list) &&
                          <ReturnShipmentServiceSummary
                            submissionList={original_submission_list}
                          />
                  }
                </div>

                <div className="col-6 col-lg-3 py-1 px-2 d-flex justify-content-start border-right-solid minH-79px">
                  {
                    renderHomePickuServiceDetails(original_submission_list) && insuranceServiceEnabled(original_submission_list) ?
                      <HomePickUpServiceSummary
                        submissionList={original_submission_list}
                      />
                    :
                      renderReturnShipmentServiceDetails(original_submission_list) && (renderHomePickuServiceDetails(original_submission_list) && !insuranceServiceEnabled(original_submission_list) || (!renderHomePickuServiceDetails(original_submission_list) && insuranceServiceEnabled(original_submission_list))) &&
                        <ReturnShipmentServiceSummary
                          submissionList={original_submission_list}
                        />
                  }
                </div>

                <div className="col-6 col-lg-3 py-1 px-2 d-flex justify-content-start minH-79px">
                  {
                    renderReturnShipmentServiceDetails(original_submission_list) && renderHomePickuServiceDetails(original_submission_list) && insuranceServiceEnabled(original_submission_list) &&
                      <ReturnShipmentServiceSummary
                        submissionList={original_submission_list}
                      />
                  }
                </div>

                {
                  isPresent(original_submission_list.middleman) && isMiddleman &&
                    <div className="col-12 py-1 px-2 d-flex justify-content-start border-top-solid minH-79px">
                      <div>
                        <img src={window.location.origin + `/images/icons/gray/file-signature.svg`} alt="note" width="16px"/>
                      </div>
                      <div className="d-block pl-2">
                        <p className="mt-1">
                          <small className="default_small_label mr-2">
                            {I18n.t('js.editSubmissionListPage.middlemanNote.title').toUpperCase()}
                          </small>
                        </p>
                        {
                          editMiddlemanNote ?
                            <textarea
                              id="middleman_note"
                              rows="1" cols="1000"
                              className={`form-control sale-item-form-input font-size-16px-imp border-left-radius-3px-imp w-100 my-1 py-1`}
                              value={middlemanNote ? middlemanNote : ''}
                              placeholder={I18n.t('js.editSubmissionListPage.middlemanNote.placeholder')}
                              autoFocus={true}
                              onChange={(e) => { setMiddlemanNote(e.target.value) }}
                            />
                            :
                            <p>
                              <span>{ middlemanNote ? middlemanNote : I18n.t('js.editSubmissionListPage.middlemanNote.notSet')}</span>
                              <i className="fas fa-fw fa-edit ml-2 cursor-pointer default_small_label"
                                 onClick={() => setEditMiddlemanNote(true) }
                              ></i>
                            </p>
                        }
                      </div>
                    </div>
                }
              </div>

              {
                (renderHomePickuServiceDetails(original_submission_list) || renderReturnShipmentServiceDetails(original_submission_list)) &&
                <div className="row shadow br-8px border-aiG-gray-imp my-5">
                  <div
                    className={`col-12 ${(renderHomePickuServiceDetails(original_submission_list) && renderReturnShipmentServiceDetails(original_submission_list)) ? 'col-md-6 border-right-md-solid border-bottom-solid border-bottom-md-none' : ''} d-flex justify-content-start pb-1`}>
                    {
                      renderHomePickuServiceDetails(original_submission_list) &&
                      <React.Fragment>
                        <div>
                          <img src={window.location.origin + `/images/icons/gray/home_pick_up.svg`} alt="home_pick_up"
                               className="mt-1"/>
                        </div>
                        <div className="d-block pl-2">
                          <p className="mt-1">
                            <small className="default_small_label mr-2">
                              {I18n.t("js.editSubmissionListPage.webComponent.confirmation.text5Compact").toUpperCase()}
                                </small>
                              </p>
                              <div>
                                {
                                  original_submission_list.home_pick_up_address ?
                                    <React.Fragment>
                                      <Address
                                        address={original_submission_list.home_pick_up_address}
                                        note={original_submission_list.home_pick_up_note}
                                        renderResidence={false}
                                        hidePhoneNumber={true}
                                        displayFullNotes={true}
                                      />

                                      {
                                        original_submission_list.home_pick_up_favorite_day_italian_format &&
                                        <p className="mt-4">
                                          <span>{I18n.t("js.editSubmissionListPage.homePickUpProgrammed")} {original_submission_list.home_pick_up_favorite_day_italian_format}</span>
                                          {
                                            original_submission_list.home_pick_up_favorite_hour && original_submission_list.home_pick_up_favorite_hour !== 'all_day' &&
                                            <span>{I18n.t("js.editSubmissionListPage.homePickUpProgrammed1")} {original_submission_list.home_pick_up_favorite_hour.split('_')[0]}:00 {I18n.t("js.editSubmissionListPage.homePickUpProgrammed2")} {original_submission_list.home_pick_up_favorite_hour.split('_')[1]}:00</span>
                                          }
                                        </p>
                                      }
                                    </React.Fragment>
                                    :
                                    <p>
                                      {I18n.t('js.newUserAddressForm.none')}
                                    </p>
                                }
                              </div>
                            </div>
                          </React.Fragment>
                      }
                    </div>

                    <div className={`col-12 ${(renderHomePickuServiceDetails(original_submission_list) && renderReturnShipmentServiceDetails(original_submission_list)) ? 'col-md-6' : ''} d-flex justify-content-start pb-1`}>
                      {
                        renderReturnShipmentServiceDetails(original_submission_list) &&
                        <React.Fragment>
                          <div>
                            <img src={window.location.origin + `/images/icons/gray/return_shipment.svg`} alt="return_shipment" className="mt-1" />
                          </div>
                          <div className="d-block pl-2">
                            <p className="mt-1">
                              <small className="default_small_label mr-2">
                                {I18n.t("js.editSubmissionListPage.webComponent.confirmation.text5_1Compact").toUpperCase()}
                              </small>
                            </p>
                            <div>
                              {
                                shipmentAddress ?
                                  <React.Fragment>
                                    <Address
                                      address={shipmentAddress}
                                      note={original_submission_list.shipment_note}
                                      renderResidence={false}
                                      hidePhoneNumber={true}
                                      displayFullNotes={true}
                                    />

                                    {
                                      shipmentAddress.can_be_updated && canEditSubmissionList &&
                                      <div className="mt-4">
                                        <p className="my-0">{I18n.t("js.editSubmissionListPage.changeShipmentAddressTxt")}</p>
                                        <p className="my-0 cursor-pointer text-underline-imp text-aiBlue"
                                           onClick={(e) => setShowModal(true)}>
                                          {I18n.t("js.editSubmissionListPage.changeShipmentAddress")}
                                        </p>
                                      </div>
                                    }
                                  </React.Fragment>
                                  :
                                  <p>
                                    {I18n.t('js.newUserAddressForm.none')}
                                  </p>
                              }
                            </div>
                          </div>
                        </React.Fragment>
                      }
                    </div>
                  </div>
              }

              <div className="text-center mt-4 mb-0 py-0">
                {
                  isPresent(original_submission_list.middleman) && isMiddleman ?
                    <React.Fragment>
                      <PDFGenerator
                        type={'button'}
                        generatorText={I18n.t('js.editSubmissionListPage.downloadSummary').toUpperCase()}
                        cssClassList={"submission_list_download_label_button color-white border-none mx-1 my-2"}
                        dataToPrint={{submissionListInfo: original_submission_list, pricingFor: 'middleman' }}
                        useTemplate={'submissionList'}
                        setShowErrorModal={setShowErrorModal}
                        customImageIcon={window.location.origin + `/images/icons/white/download-pdf.svg`}
                        spinnerCssClassList={'maxH-17px max-w-17px'}
                        downloadMsgCssClassList={'text-uppercase'}
                      />

                      <PDFGenerator
                        type={'button'}
                        generatorText={I18n.t('js.editSubmissionListPage.downloadCustomerSummary').toUpperCase()}
                        cssClassList={"submission_list_download_label_button color-white border-none mx-1 my-2"}
                        dataToPrint={{submissionListInfo: original_submission_list, pricingFor: 'customer' }}
                        useTemplate={'submissionList'}
                        setShowErrorModal={setShowErrorModal}
                        customImageIcon={window.location.origin + `/images/icons/white/download-pdf.svg`}
                        spinnerCssClassList={'maxH-17px max-w-17px'}
                        downloadMsgCssClassList={'text-uppercase'}
                      />
                    </React.Fragment>
                  :
                    <PDFGenerator
                      type={'button'}
                      generatorText={I18n.t('js.editSubmissionListPage.downloadSummary').toUpperCase()}
                      cssClassList={"submission_list_download_label_button color-white border-none mx-1 my-2"}
                      dataToPrint={{submissionListInfo: original_submission_list, pricingFor: 'customer' }}
                      useTemplate={'submissionList'}
                      setShowErrorModal={setShowErrorModal}
                      customImageIcon={window.location.origin + `/images/icons/white/download-pdf.svg`}
                      spinnerCssClassList={'maxH-17px max-w-17px'}
                      downloadMsgCssClassList={'text-uppercase'}
                    />
                }

                {
                  !original_submission_list.hide_shipment_and_invoicing_info_to_user && !['payment_alert', ...SUBMISSION_LIST_POSTERIOR_UPON_RECEIPT_STATES].includes(original_submission_list.state) &&
                    <PDFGenerator
                      type={'button'}
                      generatorText={I18n.t('js.editSubmissionListPage.downloadShipmentLabel').toUpperCase()}
                      cssClassList={`submission_list_download_label_button color-white border-none mx-1 my-2`}
                      dataToPrint={{ ...original_submission_list, force_grader_company_address_rendering: isMiddleman }}
                      useTemplate={'submissionListShipmentLabel'}
                      setShowErrorModal={setShowErrorModal}
                      customImageIcon={window.location.origin + `/images/icons/white/camion.svg`}
                      spinnerCssClassList={'maxH-17px max-w-17px'}
                      downloadMsgCssClassList={'text-uppercase'}
                    />
                }

                {
                  original_submission_list.invoice_link &&
                  <a href={original_submission_list.invoice_link} target="_blank"
                     className="submission_list_download_label_button color-white border-none mx-1 my-2"
                  >
                    <img src={window.location.origin + `/images/icons/white/contract.svg`} alt="" height="17px" />
                    {I18n.t('js.editSubmissionListPage.downloadInvoice').toUpperCase()}
                  </a>
                }
              </div>
            </div>




            <div id="submission_list_content_container" className="my-5">
              {/*  SEZIONE ARTICOLI PRESENTI IN SUBMISSION */}
              <SubmissionListContent
                submissionList={original_submission_list}
                handleShowLargeImage={handleShowLargeImage}
                isMiddleman={isMiddleman}
              />




              <div className="row mt-5 pt-5">
                {/*  SEZIONE RISERVATA ALLA VALUTAZIONE DELL'ORDINE DA PARTE DEL CLIENTE */}
                <div className="col-12 col-xl-7 py-3 pr-xl-5">
                  {
                    feedbacks && feedbacks.length > 0 &&
                    <React.Fragment>
                      <div className="row bg-aig-gradient w-100 mx-0 align-items-center py-3 px-3 br-top-8px color-white font-size-18px text-weight-600">
                        { (!isMiddleman || original_submission_list.can_be_evaluated_by_current_user) ? I18n.t('js.feedbacks.title') : I18n.t('js.feedbacks.titleForMiddleman') }
                      </div>

                      <div className="row w-100 mx-0 border-right-solid">
                        {
                          feedbacks.map((feedback, i) => {
                            return <div id={feedback.id} key={feedback.id}
                              className={`${i < feedbacks.length - 1 ? 'col-6 col-md-3' : 'col-' + (12 - ((feedbacks.length - 1) % 2) * 6) + ' col-md-' + (12 - ((feedbacks.length - 1) % 4) * 3)} w-100 p-2 border-left-solid border-bottom-solid d-flex flex-directions-column justify-content-between`}>
                              <span className="color-gray font-size-14px">
                                { parseFeedbackName(feedback.name).toUpperCase() }
                              </span>
                              <div className="mt-2">
                                {
                                  SUBMISSION_LISTS_EVALUATIONS.map((value) => {
                                    const evaluationByFeedback = getEvaluationByFeedback(feedback, evaluations)
                                    return (
                                      <i className={`fas fa-star ${value !== 5 ? 'mr-3 mr-xl-2 mr-xxl-3' : ''} ${cabBeEvaluated() ? 'cursor-pointer' : ''} ${isPresent(evaluationByFeedback) && evaluationByFeedback >= value ? "color-yellow" : "icon-light-gray4"}`}
                                         id={`${feedback.id}_evaluation_${value}_for_submission_list_${original_submission_list.id}`}
                                         key={`${feedback.id}_evaluation_${value}_for_submission_list_${original_submission_list.id}`}
                                         onClick={() => updateEvaluation(feedback.id, value)}
                                      />)
                                  })
                                }
                              </div>
                            </div>
                          })
                        }
                      </div>

                      <div className="row w-100 mx-0 border-right-solid border-left-solid border-bottom-solid br-bottom-8px">
                        <div className="col-12 w-100 p-2" id="review" key="review">
                          <span className="color-gray font-size-14px">
                            {I18n.t('js.editSubmissionListPage.yourObservations').toUpperCase()}
                          </span>
                          <div className="mt-2">
                            <textarea
                              name="review" id="review"
                              rows="3" cols="20"
                              className="form-control review-textarea overflow-hidden pt-1"
                              placeholder={(isMiddleman && !original_submission_list.can_be_evaluated_by_current_user) ? I18n.t('js.editSubmissionListPage.yourObservationsPlaceholderForMiddleman') : (isInAClosingState(original_submission_list) ? (I18n.t(`js.editSubmissionListPage.yourObservationsPlaceholder${!original_submission_list.evaluation_time_limit_expired ? '1' : '3'}`)) : I18n.t('js.editSubmissionListPage.yourObservationsPlaceholder2'))}
                              disabled={!cabBeEvaluated()}
                              value={review ? review : ''}
                              onChange={(e) => setReview(isPresent(e.target.value) ? e.target.value : '')}
                            />
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  }
                </div>

                <div className="col-12 col-xl-1"></div>



                {/*  SEZIONE RISERVATA AL RIEPILOGO DEL PRICING DELL'ORDINE */}
                <div className="col-12 col-sm-8 col-xl-4 pt-3 pb-5" id="pricing_summary_section">
                  <div className="d-block br-8px border-aiG-gray-imp py-2">
                    <div className="d-flex justify-content-between align-items-end py-1 px-3">
                      <div>
                        <b>
                          {I18n.t('js.editSubmissionListPage.webComponent.draft.payment.amountsVatExcluded').toUpperCase()}
                        </b>
                      </div>
                    </div>

                    {/* Importo relativo ai servizi di gradingdegli articoli */}
                    <div className="d-flex justify-content-between align-items-end py-1 px-3">
                      <div>
                        <span className="color-gray">
                          {I18n.t('js.editSubmissionListPage.webComponent.draft.payment.gradingServices').toUpperCase()}
                        </span>
                      </div>
                      <div>
                        <b>
                          {parseAmount(original_submission_list[`${isPresent(original_submission_list.middleman) && !isMiddleman ? 'customer_' : ''}grading_service_amount_vat_excluded`], 2, true)}{CURRENCY_EURO}
                        </b>
                      </div>
                    </div>

                    {/* Eventuale sconto applicato dall'utente sull'importo relativo ai servizi di grading */}
                    <div className="d-flex justify-content-between align-items-end py-1 px-3">
                      <div>
                        <span className="color-gray">
                          {I18n.t('js.editSubmissionListPage.webComponent.draft.payment.gradingServicesDiscount').toUpperCase()}
                        </span>
                      </div>
                      <div>
                        <b>
                          {
                            hasValidVoucher(original_submission_list) ?
                              '-' + (
                                original_submission_list.voucher.amount ?
                                  parseAmount(original_submission_list.voucher.amount, 2) + CURRENCY_EURO
                                  :
                                  original_submission_list.voucher.percentage + '%'
                              )
                              :
                              '--'
                          }
                        </b>
                      </div>
                    </div>

                    {/* Importo relativo alle varie spedizioni (ritiro a domicilio della sub e/o consegna di ritorno) */}
                    {
                      (homePickUpServiceEnabled(original_submission_list) || returnShipmentServiceEnabled(original_submission_list)) &&
                      <div className="d-flex justify-content-between align-items-end py-1 px-3">
                        <div>
                          <span className="color-gray">
                            {I18n.t('js.editSubmissionListPage.webComponent.draft.payment.shipping').toUpperCase()}
                          </span>
                        </div>
                        <div>
                          <b>
                            {parseAmount(original_submission_list[`${isPresent(original_submission_list.middleman) && !isMiddleman ? 'customer_' : ''}global_shipping_cost_vat_excluded`], 2, true)}{CURRENCY_EURO}
                          </b>
                        </div>
                      </div>
                    }

                    {/* Importo relativo al servizio di assicurazione del pacco durante le varie spedizioni */}
                    {
                      insuranceServiceEnabled(original_submission_list) &&
                      <div className="d-flex justify-content-between align-items-end py-1 px-3">
                        <div>
                          <span className="color-gray">
                            {I18n.t('js.editSubmissionListPage.webComponent.draft.payment.shippingInsurance').toUpperCase()}
                          </span>
                        </div>
                        <div>
                          <b>
                            {parseAmount(original_submission_list[`${isPresent(original_submission_list.middleman) && !isMiddleman ? 'customer_' : ''}insurance_cost_vat_excluded`], 2, true)}{CURRENCY_EURO}
                          </b>
                        </div>
                      </div>
                    }

                    {/* Sub totale iva esclusa */}
                    <div className="d-flex justify-content-between align-items-end py-1 px-3 border-top-solid">
                      <div>
                        <b>
                          {I18n.t('js.editSubmissionListPage.webComponent.draft.payment.subtotalVatExcluded').toUpperCase()}
                        </b>
                      </div>
                      <div>
                        <b>
                          {parseAmount(original_submission_list[`${isPresent(original_submission_list.middleman) && !isMiddleman ? 'customer_' : ''}all_services_amount_vat_excluded`], 2, true)}{CURRENCY_EURO}
                        </b>
                      </div>
                    </div>

                    {/* Aliquota IVA */}
                    <div className="d-flex justify-content-between align-items-end py-1 px-3">
                      <div>
                        <span className="color-gray">
                          {I18n.t('js.editSubmissionListPage.webComponent.draft.vatRate').toUpperCase()}
                        </span>
                      </div>
                      <div>
                        <b>
                          {original_submission_list[`${isPresent(original_submission_list.middleman) && !isMiddleman ? 'customer_' : ''}vat_rate`]}%
                        </b>
                      </div>
                    </div>

                    {/* Importo IVA */}
                    <div className="d-flex justify-content-between align-items-end py-1 px-3">
                      <div>
                        <span className="color-gray">
                          {I18n.t('js.editSubmissionListPage.webComponent.draft.vatAmount').toUpperCase()}
                        </span>
                      </div>
                      <div>
                        <b>
                          {parseAmount(original_submission_list[`${isPresent(original_submission_list.middleman) && !isMiddleman ? 'customer_' : ''}vat_amount`], 2, true)}{CURRENCY_EURO}
                        </b>
                      </div>
                    </div>

                    {/* Sub totale iva inclusa */}
                    <div className="d-flex justify-content-between align-items-end py-1 px-3 border-top-solid">
                      <div>
                        <b>
                          {I18n.t('js.editSubmissionListPage.webComponent.draft.payment.subtotalVatIncluded').toUpperCase()}
                        </b>
                      </div>
                      <div>
                        <b>
                          {parseAmount(original_submission_list[`${isPresent(original_submission_list.middleman) && !isMiddleman ? 'customer_' : ''}all_services_amount`], 2, true)}{CURRENCY_EURO}
                        </b>
                      </div>
                    </div>

                    {/* Eventuale credito usato dall'utente per pagare la submission list */}
                    <div className="d-flex justify-content-between align-items-end py-1 px-3">
                      <div>
                        <span className="color-gray">
                          {I18n.t('js.editSubmissionListPage.webComponent.draft.payment.piggyBankUsed').toUpperCase()}
                        </span>
                      </div>
                      <div>
                        <b>
                          -{parseAmount(original_submission_list.user_credit, 2, true)}{CURRENCY_EURO}
                        </b>
                      </div>
                    </div>

                    {/* TOTALE FINALE */}
                    <div className="d-flex justify-content-between align-items-end py-1 px-3 border-top-solid">
                      <div>
                          <b>
                            {I18n.t('js.editSubmissionListPage.webComponent.draft.payment.amountVatIncluded').toUpperCase()}
                          </b>
                      </div>
                      <div>
                        <b>
                          {parseAmount(original_submission_list[`${isPresent(original_submission_list.middleman) && !isMiddleman ? 'customer_' : ''}amount`], 2, true)}{CURRENCY_EURO}
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <AddressFormContainerModal
              showModal={showModal}
              setShowModal={setShowModal}
              shipmentAddress={shipmentAddress}
              updateShipmentAddressParams={updateShipmentAddressParams}
              countries={countries}
              updateShipmentAddress={updateShipmentAddress}
              canUpdate={canEditSubmissionList}
              addressType={'user'}
            />

            <ShowLargeImageModal
              blueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
              showZoomImg={showZoomImg}
              setShowZoomImg={setShowZoomImg}
            />

            <ErrorModal
              showErrorModal={showErrorModal}
              setShowErrorModal={setShowErrorModal}
            />

            <SuccessFlashMessage
              showSuccessFlashMessage={showSuccessFlashMessage}
              setShowSuccessFlashMessage={setShowSuccessFlashMessage}
            />
          </React.Fragment>
      }
    </React.Fragment>
  );
};

export default ShowPageSubmissionList;